export default __webpack_public_path__ + "static/media/landing-logo-black.eaddb122.svg";